import React from 'react';

export const RestInputContext = React.createContext({});
